import { gql } from '@apollo/client';

// export const getComposedForm = gql`
//   query GetComposedForm(
//     $formName: String!
//     $frontEndName: String!
//     $clientName: String!
//   ) {
//     composedForm(
//       formName: $formName
//       frontEndName: $frontEndName
//       clientName: $clientName
//     ) {
//       id
//       versionedId
//       versionHash
//       questions {
//         name
//         label
//         labelExpression
//         description
//         valueType
//         queryType
//         subLabel
//         valueOptions {
//           value
//           display
//           extraDisplayExpression
//         }
//         valueMapping
//         unit
//         defaultValue
//         defaultValueExpression
//         visibleExpression
//         enabledExpression
//         requiredExpression
//         editableExpression
//         validators
//         mapping
//       }
//       layout {
//         steps
//       }
//     }
//   }
// `;

export const getComposedForm = gql`
query GetComposedForm(
    $formName: String!
    $frontEndName: String!
    $clientName: String!
    $values: Any
) {
    fullComposedForm(
        formName: $formName
        frontEndName: $frontEndName
        clientName: $clientName
        values: $values
    )
}`;

export default getComposedForm;
